const cachePool = store => {
  store.on("@init", () => ({ cachePool: [] }));
  store.on("cachePool/add", ({ cachePool }, key) => {
    return { cachePool: [...cachePool, key] };
  });
  store.on("cachePool/remove", ({ cachePool }, key) => {
    return { cachePool: cachePool.filter(k => key !== k) };
  });
};

export default cachePool;
